import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-14 h-14 rounded-full bg-primary/30 animate-pulse" data-testid="auth-loading" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  const onboarded = user.profile?.onboarding_complete;
  if (!onboarded && location.pathname !== "/onboarding") return <Navigate to="/onboarding" replace />;
  if (onboarded && location.pathname === "/onboarding") return <Navigate to="/app" replace />;
  return children;
}
